import _ from "underscore";
import { ExpandableItem } from "./ExpandableItem";
import DriveView from "../../../DriveView";
import { handleApi } from "../../../utils/error";
import pageHTML from "./expandableItem.tmpl";

const EXPANDED_CLASS = "expandableList__item--expanded";

export class ExpandableItemView extends DriveView<ExpandableItem> {

    el: HTMLLIElement;
    private readonly template  = _.template(pageHTML);

    constructor(options) {
        super(options);
        this.listenTo(this.model, "change", this.render.bind(this));
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click .expandableList__item": this.toggle
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    toggle() {
        this.model.toggle();
    }

    render() {
        this.el.className = `item expandableList__item`;
        this.model.get("expanded") ? this.el.classList.add(EXPANDED_CLASS) : this.el.classList.remove(EXPANDED_CLASS);
        this.el.setAttribute("data-id", this.model.get("id"));
        this.display(this.template(this.model.toJSON())).catch(handleApi);
        return this;
    }
}